export function getRandomHexColor() {
  return `#${Math.floor(Math.random() * 16777215).toString(16)}`
}

export function stringToColor(string) {
  let hash = 0
  let i

  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash)
  }

  let color = '#'

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff
    color += `00${value.toString(16)}`.slice(-2)
  }

  return color
}

export default function rgbToHex(rgbColorArray: number[]): string {
  return `#${rgbColorArray[0].toString(16).padStart(2, '0')}${rgbColorArray[1]
    .toString(16)
    .padStart(2, '0')}${rgbColorArray[2].toString(16).padStart(2, '0')}`
}

export function hexToRGB(hex: string): [number, number, number] {
  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)

  return [r, g, b]
}

export function hexToRGBA(hex: string, alpha?: number): [number, number, number, number] {
  const rgb = hexToRGB(hex)
  return [rgb[0], rgb[1], rgb[2], (alpha || 1) * 255]
}

export function isValidHex(hex) {
  return /^#[0-9A-F]{6}$/i.test(hex)
}

export function isValidRGB(rgb) {
  return rgb.r >= 0 && rgb.r <= 255 && rgb.g >= 0 && rgb.g <= 255 && rgb.b >= 0 && rgb.b <= 255
}

export function getColorIndex(string?: string) {
  const randomLetter = Math.random().toString(36).substring(2, 3)
  const value = string || randomLetter
  // Sum the character codes of the string to generate a number
  const sum = value.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0)

  return sum % 11 // There are 11 qualitative colors
}
